const header = document.querySelector('.header');

if (window.innerWidth >= 990) {
	const menuItems = document.querySelectorAll('.header__nav-item');

	menuItems.forEach(function(dropdownItem) {
		const link = dropdownItem.querySelector('.header__nav-link');
		const dropdown = dropdownItem.querySelector('.header__nav-dropdown');
		if (link) link.addEventListener('mousemove', function(event) {
			if (dropdown) {
				event.preventDefault();
				dropdown.classList.add("header__nav-item-open");
				header.classList.add('has-nav-item-open');
			}

			menuItems.forEach(function(item) {
				if (item !== dropdownItem) {
					item.querySelector('.header__nav-dropdown')?.classList.remove('header__nav-item-open');
				}
			});
		});
	});

	document.querySelector('main').addEventListener('mouseenter', () => {
		menuItems.forEach(function(item) {
			item.querySelector('.header__nav-dropdown')?.classList.remove('header__nav-item-open');
		});
	});
	
	window.addEventListener('click', function(event) {
		if (!header.contains(event.target)) {
			const dropdowns = header.querySelectorAll('.header__nav-dropdown');
			dropdowns.forEach(function(dropdown) {
				dropdown.classList.remove('header__nav-item-open');
			});
			header.classList.remove('has-nav-item-open');
		}
	});
}
    